import { useEffect, useState } from 'react'
import { clientConfig } from '../client'
import { config } from '../lib'
import { getParameterByName } from '../utils'

const SPRINT_INFO = {
  sprint: 'Shorts 3',
  tasks: [
    { id: 'SHORTS-40', desc: 'Stories display overlay on content cards' },
    { id: 'SHORTS-41', desc: 'hide shorts row in app (hideInApp)' },
    { id: 'SHORTS-42', desc: 'overlay asked again when a request is dropped' },
    { id: 'SHORTS-43', desc: 'overlay stays through a refresh of its slot' },
    { id: 'SHORTS-44', desc: 'player plays the block as a series (temp)' },
  ],
}

export const DebugConsoleLog = () => {
  const [runLogVersion, setRunLogVersion] = useState(false)

  useEffect(() => {
    const logVersion = getParameterByName('logVersion')
    if (clientConfig.adTargetEnv !== 'prod' || logVersion) {
      setRunLogVersion(true)
    }
  }, [])

  useEffect(() => {
    if (runLogVersion) {
      const buildTime = config.buildTime
        ? new Date(config.buildTime).toLocaleString('he-IL', {
            timeZone: 'Asia/Jerusalem',
          })
        : ''
      console.log(
        `%cyou are on sprint ${SPRINT_INFO.sprint} · build ${config.buildHash}${
          buildTime ? ` · ${buildTime}` : ''
        }`,
        'font-size:24px;font-weight:bold;color:red',
        { tasks: SPRINT_INFO.tasks }
      )
    }
  }, [runLogVersion])

  return null
}
